export enum Language {
  English = 'en',
  German = 'de',
  Spanish = 'es',
}

export interface TranslationKeys {
  home_button: string;
  back_button: string;
  clear_button: string;
  search_placeholder: string;
  search_ai_powered_caption: string;
  most_requested_resources: string;
  looking_for_something_else: string;
  live_chat_online_title: string;
  live_chat_offline_title: string;
  live_chat_prompt_placeholder: string;
  form_submit: string;
  form_skip: string;
  contact_details: string;
  skipped: string;
  itemWithCount_one: string;
  itemWithCount_other: string;
  and: string;
  only_in_english: string;
  read_more: string;
  error_header: string;
  error_subheader: string;
  new_version_available_header: string;
  new_version_available_subheader: string;
  reload_page: string;
  connecting_message: string;
  conversation_archived: string;
  next_suggested_article: string;
  no_results_found: string;
  search_tips: string;
  check_spelling: string;
  use_different_keywords: string;
  use_specific_terms: string;
  contact_form_has_errors: string;
}
